
function deleteAssetPackDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/delete-asset-pack/delete-asset-pack-dialog.html?$$REVISION$$'
  }
}

export { deleteAssetPackDialog }
